module.exports = __webpack_public_path__ + "img/Android_Female_idle.aad3c71c.png";